var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.092,
    height: 32,
    viewBox: "0 0 31.092 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "export-svgrepo-com",
    transform: "translate(-7.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44111",
    "data-name": "Path 44111",
    d: "M37.2,34.186h1.976V15.928L33.247,10H17.12V40.725H39.176V38.266H37.2Z",
    transform: "translate(-9.363 -9.363)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44112",
    "data-name": "Path 44112",
    d: "M337.627,351.1a.911.911,0,0,0-1.555.644v.636a.911.911,0,0,1-.911.911H332.12v4.08h3.041a.911.911,0,0,1,.911.911v.636a.911.911,0,0,0,1.555.644l4.231-4.231Z",
    transform: "translate(-304.283 -328.471)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11756",
    "data-name": "Group 11756",
    transform: "translate(7.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44113",
    "data-name": "Path 44113",
    d: "M270.12,15.928V10l5.928,5.928Z",
    transform: "translate(-253.355 -9.363)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11755",
    "data-name": "Group 11755",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44114",
    "data-name": "Path 44114",
    d: "M38.026,26.412l-4.231-4.231a1.548,1.548,0,0,0-2.643,1.095v.636a.274.274,0,0,1-.273.273h-.428V6.566a.638.638,0,0,0-.187-.451L24.336.187A.638.638,0,0,0,23.885,0H7.757A.637.637,0,0,0,7.12.637V31.363A.637.637,0,0,0,7.757,32H29.813a.637.637,0,0,0,.637-.637V29.541h.428a.274.274,0,0,1,.273.273v.636a1.548,1.548,0,0,0,2.643,1.095l4.231-4.231a.637.637,0,0,0,0-.9ZM24.522,2.176l3.752,3.752H24.522Zm4.653,28.549H8.395V1.275H23.247V6.566a.637.637,0,0,0,.637.637h5.291V24.186H27.837a.637.637,0,0,0-.637.637V28.9a.637.637,0,0,0,.637.637h1.339Zm-.7-2.459v-2.8h2.4a1.55,1.55,0,0,0,1.548-1.548v-.636a.273.273,0,0,1,.466-.193h0l3.78,3.78-3.78,3.78a.273.273,0,0,1-.466-.193v-.636a1.55,1.55,0,0,0-1.548-1.548Z",
    transform: "translate(-7.12 0)",
    fill: "#cbc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44115",
    "data-name": "Path 44115",
    d: "M68.257,155.275h10.55a.637.637,0,0,0,0-1.275H68.257a.637.637,0,0,0,0,1.275Z",
    transform: "translate(-63.763 -144.183)",
    fill: "#cbc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44116",
    "data-name": "Path 44116",
    d: "M82.6,220H68.257a.637.637,0,0,0,0,1.275H82.6a.637.637,0,0,0,0-1.275Z",
    transform: "translate(-63.763 -205.976)",
    fill: "#cbc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44117",
    "data-name": "Path 44117",
    d: "M82.6,286H68.257a.637.637,0,0,0,0,1.275H82.6a.637.637,0,0,0,0-1.275Z",
    transform: "translate(-63.763 -267.769)",
    fill: "#cbc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44118",
    "data-name": "Path 44118",
    d: "M82.6,352H68.257a.637.637,0,0,0,0,1.275H82.6a.637.637,0,0,0,0-1.275Z",
    transform: "translate(-63.763 -329.562)",
    fill: "#cbc3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44119",
    "data-name": "Path 44119",
    d: "M272.66,154h-1.4a.637.637,0,0,0,0,1.275h1.4a.637.637,0,0,0,0-1.275Z",
    transform: "translate(-253.823 -144.183)",
    fill: "#cbc3d6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.1e5b1457bd9169dc608f021a41158dce.svg";
export { ForwardRef as ReactComponent };